import { Navigate, useParams } from "react-router-dom";

export default function RedirectToNotebookNote() {
  const { noteId } = useParams<{ noteId: string }>();
  return <Navigate to={`/discipline-manager/note/${noteId}`} replace />;
}
